export const SurveysPermissions = [
  "surveys.create",
  "surveys.read",
  "surveys.update",
  "surveys.delete",
  "surveys.publish",
  "surveys.unpublish",
  "surveys.manage_groups",
  "surveys.read_stats",
  "surveys.download_csv",
  "surveys.count_publishing",
] as const;

export const SurveyAnswersPermissions = [
  "survey_answers.delete",
  "survey_answers.count",
] as const;

const GrafferUtilityToolsPermissions = [
  "graffer_utility_tools.generate_matrix_code",
] as const;

const PermissionsList = [
  ...SurveysPermissions,
  ...SurveyAnswersPermissions,
  ...GrafferUtilityToolsPermissions,
] as const;

export type GrafferPermissions = (typeof PermissionsList)[number];
